// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountV2SiteAccountSiteAccountsByPortalIdSiteAccountsByPortalIdResponse {
    static getAttributeTypeMap() {
        return SiteAccountV2SiteAccountSiteAccountsByPortalIdSiteAccountsByPortalIdResponse.attributeTypeMap;
    }
}
SiteAccountV2SiteAccountSiteAccountsByPortalIdSiteAccountsByPortalIdResponse.discriminator = undefined;
SiteAccountV2SiteAccountSiteAccountsByPortalIdSiteAccountsByPortalIdResponse.additionalProperties = false;
SiteAccountV2SiteAccountSiteAccountsByPortalIdSiteAccountsByPortalIdResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "GetSiteAccountsResponseModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=siteAccountV2SiteAccountSiteAccountsByPortalIdSiteAccountsByPortalIdResponse.js.map